import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import Moment from "moment";
import TimeCounter from "../../../../../containers/TimeCounter";
import unicodeToChar from "../../../../../actions/formatUnicode";
import Typography from "../../../../Typography";
import { Popover, Tooltippy } from "../../../../../actions/Tippy";
import {
  getCommentHistoric,
  getIPBaseURL,
} from "../../../../../services/nps/functions";
import Audio from "../../../../../components/Audio/Audio";
import urlIngWeb from "../../../../../actions/urlIngWeb";
import MicRecorder from "mic-recorder-to-mp3";

import VIDEO from "../../../../../build/images/video.jpg";
import AUDIO from "../../../../../build/images/audio.svg";
import FOTO from "../../../../../build/images/foto.svg";
import DOC from "../../../../../build/images/doc.svg";

import { ReactComponent as MessageComment } from "../../../../../build/images/nps-dashboard-icons/messagecomment.svg";
import { ReactComponent as IconClips } from "../../../../../build/images/chatIcons/Clips.svg";
import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as ArrowBackIcon } from "../../../../../build/images/arrow_back.svg";
import { ReactComponent as IconUploadFile } from "../../../../../build/images/link-2.svg";
import { ReactComponent as IconAudio } from "../../../../../build/images/microphone-2.svg";
import { ReactComponent as IconSend } from "../../../../../build/images/send-2.svg";
import { ReactComponent as IconMoreVertical } from "../../../../../build/images/MoreVertical.svg";
import AttachTypeFiles from "../../../../AttachTypeFiles/AttachTypeFiles";
import axios from "axios";
import { connection_platform } from "../../../../../services/api";
import { DownloadFileReturnURL } from "../../../../../actions";
import CommentImage from "../../../../CommentImage/CommentImage";
import convertUnicodeEmoji from "../../../../../actions/convertUnicodeEmoji";
import blockClick from "../../../../../actions/blockClick";

const typeName = "";
const apiBaseUrl = getIPBaseURL();
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

let dia = "";
let auxdia = "";
let permitrec = true;
let AudioFile = [];

if (connection_platform.type_connect === "https") {
  permitrec = false;
}

const Comment = ({ userHistoryDrawer, onCloseDrawer, treatmentData }) => {
  const containers = useRef();
  const [selectedFile, setSelectedFile] = useState("");
  const [textMessage, setTextMessage] = useState("");
  const itemsPerPageOptions = [5, 10, 20];
  const [blobURL, setBlobUrl] = useState("");
  const mimetypesPrincipal = [
    "image",
    "voice",
    "document",
    "audio",
    "txt",
    "video",
  ];
  const [timeRecording, setTimeRecording] = useState(0);
  const [showReply, setShowReply] = useState(false);
  const [idReplyMsg, setIdReplyMsg] = useState(0);
  const [isBlocked, setIsBlocked] = useState(false);
  const [reply, setReply] = useState([]);
  const [userHistory, setUserHistory] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusDownload, setStatusDownload] = useState(false);
  const [recording, setRecording] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [fileasw, setFileasw] = useState([]);
  const [commentImg, setCommentImg] = useState(false);
  const [visible, setVisible] = useState(false);
  const [commentVideo, setCommentVideo] = useState(false);
  const InfoUsers = useSelector((state) => state.informationusers);
  const [scroller, setScroller] = useState(0);
  const mimetypesList = useSelector((state) => state.mimetypes);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userHistory.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  function handleComment(idComment) {
    const comment = document.querySelector(`#comentario-${idComment}`);
    if (comment) {
      comment.scrollIntoView({ behavior: "smooth", block: "center" });
      comment.classList.add("comment-active");
      setTimeout(() => {
        comment.classList.remove("comment-active");
      }, 2000);
    }
  }

  function getBackgroundColor(npsNote) {
    if (npsNote >= 0 && npsNote <= 6) {
      return "#c90000";
    } else if (npsNote === 7 || npsNote === 8) {
      return "#F2BD00";
    } else if (npsNote === 9 || npsNote === 10) {
      return "#008908";
    } else {
      return "#c90000";
    }
  }

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  function tratarUnderline(valor) {
    valor = valor.split(" ");
    const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let valorFim = [];
    for (let variavel of valor) {
      if (!expresionRegular.test(variavel)) {
        variavel = variavel
          .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
          .replaceAll("\n", "</br>")
          .replaceAll('"}', "")
          .replaceAll("\\n", "</br>")
          .replaceAll("\n", "</br>")
          .replaceAll("\\r", "")
          .replaceAll("\r", "")
          .replace(/_(.*?)_/g, "<em>$1</em>");
      }
      valorFim.push(unicodeToChar(variavel));
    }
    return valorFim.join(" ");
  }

  function formatEmoji(item) {
    if (item) {
      let mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        let obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  function renderCommentAnswered(structMsg) {
    if (structMsg) {
      let filterParent = reply.filter(
        (list) => list.id === structMsg.id_parent,
      );
      if (filterParent.length !== 0) {
        const todo = filterParent[0];
        if (mimetypesPrincipal.includes(todo.typeName)) {
          return (
            <a
              href={`#comentario-${todo.id}`}
              className="comment-content__response"
              onClick={(e) => {
                e.preventDefault();
                handleComment(todo.id);
              }}
            >
              <div className="response-divider"></div>
              <div className="response-content">
                <Typography.H6 color="gray-180" weight={"bold"}>
                  {formatEmoji(todo.username)}
                </Typography.H6>

                <Typography.H6 color="gray-180" weight={400}>
                  <IconClips />
                  &nbsp; Ir para o(s) anexo(s)
                </Typography.H6>
              </div>
            </a>
          );
        } else if (todo.typeName === "Interactive") {
          let text = todo.mensagem;
          let textNew = unicodeToChar(text);
          let textReplace = tratarUnderline(textNew);
          const textExhib = ReactHtmlParser(`<p>${textReplace}</p>`);

          return (
            <a
              href={`#comentario-${todo.id}`}
              className="comment-content__response"
              onClick={(e) => {
                e.preventDefault();
                handleComment(todo.id);
              }}
            >
              <div className="response-divider"></div>
              <div className="response-content">
                <Typography.H6 color="gray-180" weight={"bold"}>
                  {formatEmoji(todo.username)}
                </Typography.H6>

                <Typography.H6 color="gray-180" weight={400}>
                  {text.length > 150
                    ? `${textExhib.slice(0, 150)}... `
                    : textExhib}
                </Typography.H6>
              </div>
            </a>
          );
        } else if (todo.mimetype === 30) {
          let text = todo.text;
          let textNew = unicodeToChar(text);
          let textReplace = tratarUnderline(textNew);
          text = ReactHtmlParser(`<p>${textReplace}</p>`);

          return (
            <a
              href={`#comentario-${todo.id}`}
              className="comment-content__response"
              onClick={(e) => {
                e.preventDefault();
                handleComment(todo.id);
              }}
            >
              <div className="response-divider"></div>
              <div className="response-content">
                <Typography.H6 color="gray-180" weight={"bold"}>
                  {formatEmoji(todo.username)}
                </Typography.H6>

                <Typography.H6 color="gray-180" weight={400}>
                  {todo.length > 150 ? `${text.slice(0, 150)}... ` : text}
                </Typography.H6>
              </div>
            </a>
          );
        } else {
          let textNew = unicodeToChar(todo.text);
          let textReplace = tratarUnderline(textNew);

          const textExhib = ReactHtmlParser(`<p>${textReplace}</p>`);

          return (
            <a
              href={`#comentario-${todo.id}`}
              className="comment-content__response"
              onClick={(e) => {
                e.preventDefault();
                handleComment(todo.id);
              }}
            >
              <div className="response-divider"></div>
              <div className="response-content">
                <Typography.H6 color="gray-180" weight={"bold"}>
                  {formatEmoji(todo.username)}
                </Typography.H6>

                <Typography.H6 color="gray-180" weight={400}>
                  {textExhib.length > 150
                    ? `${textExhib.slice(0, 150)}... `
                    : textExhib}
                </Typography.H6>
              </div>
            </a>
          );
        }
      }
    }
  }

  const renderInteractionComment = (todo) => {
    const typeComment = () => {
      if (todo.type === "attachment") {
        if (todo.typeName === "audio" || todo.typeName === "voice") {
          return (
            <div className="comment-content">
              {renderCommentAnswered(todo)}
              {todo.attachment && todo.attachment.path_arquivos && (
                <Audio link={todo.attachment.path_arquivos} />
              )}
            </div>
          );
        } else {
          let htmlText = tratarUnderline(todo.text);
          return (
            <div className="comment-content">
              {renderCommentAnswered(todo)}
              <div className="comment-content__files">
                {renderFileComment(todo)}
              </div>
              {todo.caption && (
                <div
                  className="comment-content__text"
                  style={{ pointerEvents: "none" }}
                  onClick={(event) => blockClick(event)}
                >
                  <Typography.H5 color="gray-180" weight={400}>
                    {ReactHtmlParser(`<p>${htmlText}<p/>`)}
                  </Typography.H5>
                </div>
              )}
            </div>
          );
        }
      } else {
        let htmlText = tratarUnderline(todo.text);
        return (
          <div className="comment-content">
            {renderCommentAnswered(todo)}
            {todo.attachment && todo.attachment.path_arquivos && (
              <div className="comment-content-buttons">
                <div
                  className={`comment-content-buttons-attachment-list ${
                    todo.attachment ? "column" : ""
                  }`}
                >
                  {renderFileComment(todo)}
                </div>
              </div>
            )}
            <div
              className="comment-content__text"
              style={{ pointerEvents: "none" }}
              onClick={(event) => blockClick(event)}
            >
              <Typography.H5 color="gray-180" weight={400}>
                {ReactHtmlParser(`<p>${htmlText}<p/>`)}
              </Typography.H5>
            </div>
          </div>
        );
      }
    };

    return (
      <div
        className={`interaction-comment ${
          todo.direction === "left" ? "blue-color" : " "
        } ${
          todo.type === "attachment"
            ? "comment-length-normal"
            : "comment-length-alternate"
        }`}
        id={`comentario-${todo.id}`}
      >
        <div className="comment-information">
          {renderTitleComment(todo.username, todo)}
        </div>
        {typeComment()}
        {renderFooter(todo.date)}
      </div>
    );
  };

  function renderFooter(date) {
    return (
      <div className="comment-footer">
        <Typography.Paragraph color="gray-200">
          {date.horaEnvio}
        </Typography.Paragraph>
      </div>
    );
  }

  function renderTitleComment(name, todo) {
    return (
      <div className="comment-information-user">
        <div className="comment-information-user__container">
          <Typography.H5 color="gray-180" weight={"bold"}>
            {formatEmoji(name)}
          </Typography.H5>
          {/* {InfoUsers.permdownload && todo.attachment && renderTippyCommentTypeTwo()} */}
          {InfoUsers.permdownload && renderTippyCommentTypeTwo(todo)}
        </div>
      </div>
    );
  }

  const refactorListComment = (listComments) => {
    const arrayComments = [];
    listComments.map((list) => {
      const getData = list.data_hora_envio.split(" ");
      const organizeData = getData[0].split("/").reverse().join("/");
      dia = organizeData;

      if (dia != auxdia) {
        dia = dia;
        auxdia = dia;
      } else {
        auxdia = dia;
        dia = "";
      }

      if (list.mimetypeid === 1) {
        arrayComments.push({
          type: "text",
          typeName: "msg",
          typemsg: `${0}`,
          id: list.id,
          caption: list.messagem,
          text: list.messagem,
          username: InfoUsers.id === list.iduser ? "Você" : list.username,
          direction: InfoUsers.id === list.iduser ? "right" : "left",
          id_parent: list.replyid,
          date: {
            horaEnvio: list.horaenvio,
            horaLida: list.horaenvio,
            horaError: list.horaenvio,
            dia: dia ? new Date(dia) : "",
          },
        });
      } else if (list.mimetypeid === 17) {
        arrayComments.push({
          type: "attachment",
          typeName: "voice",
          typemsg: `${17}`,
          id: list.id,
          caption: list.messagem ? list.messagem : "",
          text: list.messagem ? list.messagem : "",
          username: InfoUsers.id === list.iduser ? "Você" : list.username,
          direction: InfoUsers.id === list.iduser ? "right" : "left",
          attachment: {
            path_arquivos: list.arquivo,
          },
          id_parent: list.replyid,
          date: {
            horaEnvio: list.horaenvio,
            horaLida: list.horaenvio,
            horaError: list.horaenvio,
            dia: dia ? new Date(dia) : "",
          },
        });
      } else {
        let typeName = mimetypesList.filter(
          (mimetype) =>
            mimetype.fileextension === "." + list.arquivo.split(".").pop(),
        );
        arrayComments.push({
          type: "attachment",
          typeName: typeName.length !== 0 ? typeName[0].typename : "text",
          id: list.id,
          typemsg: `${typeName[0].id}`,
          caption: list.messagem ? list.messagem : "",
          text: list.messagem ? list.messagem : "",
          username: InfoUsers.id === list.iduser ? "Você" : list.username,
          direction: InfoUsers.id === list.iduser ? "right" : "left",
          attachment: {
            path_arquivos: list.arquivo,
          },
          id_parent: list.replyid,
          date: {
            horaEnvio: list.horaenvio,
            horaLida: list.horaenvio,
            horaError: list.horaenvio,
            dia: dia ? new Date(dia) : "",
          },
        });
      }
    });
    setReply(arrayComments);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await getCommentHistoric(treatmentData.id_atendimento);

      if (response.status !== 200) return;

      if (response.status === 200) {
        if (response.data.length !== 0) {
          refactorListComment(response.data);
        }
      }
    };

    fetchData();
    document.getElementById("contein").style.display = "none";

    if (connection_platform.type_connect === "https") {
      navigator.getMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      navigator.getMedia(
        { audio: true },
        () => {
          setIsBlocked(false);
        },
        () => {
          setIsBlocked(true);
        },
      );
    }
  }, []);

  useEffect(() => {
    if (isRecording && blobURL !== "") {
      uploadAudioFileAction();
    }

    async function uploadAudioFileAction() {
      setIsRecording(false);
      let data = new FormData();
      let hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let namefile = random + ".mp3";
      data.append("file", blobURL, namefile);
      AudioFile = data;
      const nameAudioFileUploaded = await DownloadFileReturnURL(AudioFile);
      setBlobUrl("");
      // colocar o caption do campo de texto na rota e limpar o campo de texto
      let msgweb = document.getElementById("chat-message").innerText;
      msgweb = msgweb.trim();
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');

      const getData = Moment().format("DD/MM/YYYY HH:mm").split(" ");
      const organizeData = getData[0].split("/").reverse().join("/");

      dia = organizeData;

      if (dia != auxdia) {
        dia = dia;
        auxdia = dia;
      } else {
        auxdia = dia;
        dia = "";
      }

      setFileasw([]);
      document.getElementById("chat-message").innerHTML = "";
      const response = await axios.get(
        `${apiBaseUrl}/insert-evaluation-comment-nps?description=${msgweb}&mimetypeid=17&user_insert=${InfoUsers.id}&path=${nameAudioFileUploaded}&id_comment_parent=${idReplyMsg !== 0 ? idReplyMsg : ""}&serviceattendantid=${treatmentData.id_atendimento}`,
      );
      if (response.data.length !== 0) {
        setReply([
          ...reply,
          {
            type: "attachment",
            typeName: "voice",
            id: response.data[0].id,
            caption: msgweb && msgweb !== "" ? msgweb : "",
            text: msgweb && msgweb !== "" ? msgweb : "",
            username: "Você",
            direction: "right",
            id_parent: idReplyMsg !== 0 ? idReplyMsg : null,
            attachment: {
              path_arquivos: nameAudioFileUploaded,
            },
            date: {
              horaEnvio: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              horaLida: Moment().format("HH"),
              horaError: Moment().format("mm"),
              dia: dia ? new Date(dia) : "",
            },
          },
        ]);
        setShowReply(false);
        setIdReplyMsg(0);
      }
    }
  }, [isRecording]);

  useEffect(() => {
    if (selectedFile !== "") {
      uploadFileAction();
    }

    async function uploadFileAction() {
      const nameFileUploaded = await DownloadFileReturnURL(selectedFile);

      let msgweb = document.getElementById("chat-message").innerText;
      msgweb = msgweb.trim();
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');

      const getData = Moment().format("DD/MM/YYYY HH:mm").split(" ");
      const organizeData = getData[0].split("/").reverse().join("/");

      dia = organizeData;

      if (dia != auxdia) {
        dia = dia;
        auxdia = dia;
      } else {
        auxdia = dia;
        dia = "";
      }

      setSelectedFile("");
      let mimetypeid = mimetypesList.filter(
        (mimetype) =>
          mimetype.fileextension === "." + nameFileUploaded.split(".").pop(),
      );
      document.getElementById("chat-message").innerHTML = "";
      const response = await axios.get(
        `${apiBaseUrl}/insert-evaluation-comment-nps?description=${msgweb}&mimetypeid=${mimetypeid.length !== 0 ? mimetypeid[0].id : 1}&user_insert=${InfoUsers.id}&path=${nameFileUploaded}&id_comment_parent=${idReplyMsg !== 0 ? idReplyMsg : ""}&serviceattendantid=${treatmentData.id_atendimento}`,
      );
      if (response.data.length !== 0) {
        setReply([
          ...reply,
          {
            type: "attachment",
            typeName: mimetypeid[0].typename,
            id: response.data[0].id,
            caption: msgweb && msgweb !== "" ? msgweb : "",
            text: msgweb && msgweb !== "" ? msgweb : "",
            username: "Você",
            direction: "right",
            id_parent: idReplyMsg !== 0 ? idReplyMsg : null,
            attachment: {
              path_arquivos: nameFileUploaded,
            },
            date: {
              horaEnvio: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              horaLida: Moment().format("HH"),
              horaError: Moment().format("mm"),
              dia: dia ? new Date(dia) : "",
            },
          },
        ]);
        setShowReply(false);
        setIdReplyMsg(0);
      }
    }
  }, [selectedFile]);

  const handleReply = (messageid) => {
    setShowReply(true);
    setIdReplyMsg(messageid);
    document.getElementById("simulation_click").click();
  };

  const renderTippyCommentTypeTwo = (todo, titleOptions = true) => {
    return (
      <Popover
        trigger="click"
        placement="bottom"
        interactive={true}
        content={
          <div className="popover-comment">
            {titleOptions && (
              <div
                className="popover-comment__item"
                onClick={() => {
                  handleReply(todo.id);
                }}
              >
                <Typography.H5 color="gray-180" weight="500">
                  Responder
                </Typography.H5>
              </div>
            )}
            {InfoUsers.permdownload && (
              <div
                className="popover-comment__item"
                onClick={() => {
                  setStatusDownload("Downloading...");
                  //   onDownload();
                }}
              >
                <Typography.H5 color="gray-180" weight="500">
                  {statusDownload}
                </Typography.H5>
              </div>
            )}
          </div>
        }
      >
        <IconMoreVertical
          className="popover-comment-icon"
          onClick={() => show()}
        />
      </Popover>
    );
  };

  const show = () => setVisible(true);

  function renderFileComment(todo) {
    if (todo.attachment) {
      if (todo.typeName === "image") {
        return (
          <CommentImage
            content={[{ file: todo.attachment }]}
            linkImg={todo.attachment ? "" : todo.text}
          />
        );
        return "";
      } else if (todo.typeName === "video") {
        return (
          <div className="bubble-media__video">
            <video className="bubble-media__video-frame" controls>
              <source
                className="bubble-media__video-file"
                src={`${urlIngWeb + todo.attachment.path_arquivos}`}
                type={`${todo.attachment.type}`}
              />
              Seu navegador nao suporta esse tipo de arquivo.
            </video>
          </div>
        );
      } else {
        return (
          <AttachTypeFiles
            files={todo.attachment}
            type="comment"
            limit={3}
            className="comment-carousel"
            download
          />
        );
      }
    } else {
      return (
        <AttachTypeFiles
          files={todo.attachment || todo.text}
          type="comment"
          limit={3}
          className="comment-carousel"
          download
        />
      );
    }
  }

  const stopIn = () => {
    setRecording(false);

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = blob;
        setBlobUrl(blobURL);
        setIsRecording(true);
      })
      .catch((e) => console.log(e));
  };

  const start = () => {
    if (isBlocked) {
    } else {
      Mp3Recorder.start()
        .then(() => {
          setRecording(true);
          setTimeRecording(0);
        })
        .catch((e) => console.error(e));
    }
  };

  const stop = () => {
    setRecording(false);
    setBlobUrl("");

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        setIsRecording(false);
      })
      .catch((e) => console.log(e));
  };

  const handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  const handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  const handleOnChange = async (event) => {
    event.preventDefault();

    if (event.key === "Enter" && event.shiftKey === false) {
      let msgweb = document.getElementById("chat-message").innerText;
      document.getElementById("chat-message").contentEditable = true;
      let infosendfile = fileasw;

      if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');

        document.getElementById("chat-message").innerHTML = "";
        setFileasw([]);
      } else {
        var img = document.getElementById("contein");
        if (img.currentSrc !== "") {
          var blobImage = await createFile(img.currentSrc);
          handleCreateFileSplit(blobImage);
          document.getElementById("contein").style.display = "block";
          document.getElementById("contein").src = "";
          blobImage = [];

          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgweb = msgweb.replace(/"/gm, '\\"');
        }

        const getData = Moment().format("DD/MM/YYYY HH:mm").split(" ");
        const organizeData = getData[0].split("/").reverse().join("/");

        dia = organizeData;

        if (dia != auxdia) {
          dia = dia;
          auxdia = dia;
        } else {
          auxdia = dia;
          dia = "";
        }

        setReply([
          ...reply,
          {
            type: "text",
            id: 1,
            caption: msgweb,
            text: msgweb,
            direction: "right",
            username: "Você",
            id_parent: idReplyMsg !== 0 ? idReplyMsg : null,
            date: {
              horaEnvio: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              horaLida: Moment().format("HH"),
              horaError: Moment().format("mm"),
              dia: dia ? new Date(dia) : "",
            },
          },
        ]);
        setShowReply(false);
        setIdReplyMsg(0);
        setFileasw([]);
        document.getElementById("chat-message").innerHTML = "";
        await axios.get(
          `${apiBaseUrl}/insert-evaluation-comment-nps?description=${msgweb}&mimetypeid=1&user_insert=${InfoUsers.id}&path=&id_comment_parent=${idReplyMsg !== 0 ? idReplyMsg : ""}&serviceattendantid=${treatmentData.id_atendimento}`,
        );
      }
    }
  };

  async function createFile(url) {
    let response = await fetch(url);
    let data = await response.blob();
    let metadata = {
      type: "image/jpeg",
    };
    let file = new File([data], "test.jpg", metadata);
    return file;
  }

  const buttonSendMessage = async () => {
    let msgweb = document.getElementById("chat-message").innerText;
    document.getElementById("chat-message").contentEditable = true;
    let infosendfile = fileasw;

    if (fileasw != null && infosendfile[2] != 1 && infosendfile.length > 0) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgweb = msgweb.replace(/"/gm, '\\"');
      document.getElementById("chat-message").innerHTML = "";
      setFileasw([]);
    } else {
      var img = document.getElementById("contein");
      if (img.currentSrc !== "") {
        var blobImage = await createFile(img.currentSrc);
        handleCreateFileSplit(blobImage);
        document.getElementById("contein").style.display = "block";
        document.getElementById("contein").src = "";
        blobImage = [];

        setFileasw([]);
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgweb = msgweb.replace(/"/gm, '\\"');
      }

      const getData = Moment().format("DD/MM/YYYY HH:mm").split(" ");
      const organizeData = getData[0].split("/").reverse().join("/");

      dia = organizeData;

      if (dia != auxdia) {
        dia = dia;
        auxdia = dia;
      } else {
        auxdia = dia;
        dia = "";
      }

      setReply([
        ...reply,
        {
          type: "text",
          id: 1,
          caption: msgweb,
          text: msgweb,
          direction: "right",
          username: "Você",
          id_parent: idReplyMsg !== 0 ? idReplyMsg : null,
          date: {
            horaEnvio: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
            horaLida: Moment().format("HH"),
            horaError: Moment().format("mm"),
            dia: dia ? new Date(dia) : "",
          },
        },
      ]);
      setShowReply(false);
      setIdReplyMsg(0);
      document.getElementById("chat-message").innerHTML = "";
      await axios.get(
        `${apiBaseUrl}/insert-evaluation-comment-nps?description=${msgweb}&mimetypeid=1&user_insert=${InfoUsers.id}&path=&id_comment_parent=${idReplyMsg !== 0 ? idReplyMsg : ""}&serviceattendantid=${treatmentData.id_atendimento}`,
      );
    }
  };

  useEffect(() => {
    if (containers && containers.current) {
      containers.current.scrollTo({
        top: containers.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [reply]);

  const handleCreateFileSplit = (file) => {
    // let filesend = file;
    // if (filesend != undefined) {
    //     this.setState({
    //     selectedFile: filesend,
    //     loaded: 0,
    //     });
    //     let data = new FormData();
    //     let namefile = filesend.name;
    //     let hora = Moment().format("HH-mm-ss");
    //     let random = Math.floor(Math.random() * 999999 + 100000);
    //     random = random + "_" + hora;
    //     let ext = namefile.split(".").pop();
    //     namefile = random + "." + ext;
    //     data.append("file", filesend, namefile);
    //     let msgweb = document.getElementById("chat-message").innerText;
    //     let msgsocket = document.getElementById("chat-message").innerText;
    //     this.props.editMsg(msgweb, contactid.idatendimento);
    //     let str = msgsocket.replace(/\s/g, "");
    //     if (str != "") {
    //     msgweb = msgweb.trim();
    //     msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
    //     msgweb = msgweb.replace(/"/gm, '\\"');
    //     msgsocket = msgsocket.trim();
    //     msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
    //     msgsocket = msgsocket.replace(/"/gm, '\\"');
    //     document.getElementById("chat-message").innerHTML = "";
    //     this.props.UploadFile(
    //         data,
    //         infousers,
    //         contactid,
    //         msgweb,
    //         makeid(32),
    //         filesend.size
    //     );
    //     } else {
    //     this.props.UploadFile(
    //         data,
    //         infousers,
    //         contactid,
    //         "",
    //         makeid(32),
    //         filesend.size
    //     );
    //     }
    // }
  };

  const removeImageSplit = () => {
    document.getElementById("contein").style.display = "none";
    document.getElementById("contein").src = "";
  };

  const handleselectedFile = (event) => {
    for (let fileUp = 0; fileUp < event.target.files.length; fileUp++) {
      let filesend = event.target.files[fileUp];

      if (filesend != undefined) {
        let data = new FormData();
        let namefile = filesend.name;
        let hora = Moment().format("HH-mm-ss");
        let random = Math.floor(Math.random() * 999999 + 100000);
        random = random + "_" + hora;
        let ext = namefile.split(".").pop();
        namefile = random + "." + ext;
        data.append("file", filesend, namefile);
        setSelectedFile(data);
      }
    }
    document.getElementById("file-input").value = "";
  };

  const closeReply = () => {
    setIdReplyMsg(0);
    setShowReply(false);
  };

  return (
    <div
      className={`user-history-container ${userHistoryDrawer ? "" : "closed"}`}
    >
      <header className="user-history-container__header">
        <div>
          <ArrowBackIcon onClick={onCloseDrawer} />

          <Typography.H1 color="blue-selected-4" weight={700}>
            Comentários
          </Typography.H1>
        </div>

        <button
          className="user-history-container__header__close"
          onClick={onCloseDrawer}
        >
          <CloseIcon />
        </button>
      </header>

      <main className="user-history-container__content">
        <div className="chat-wrapper is-visible" id="chat-wrapper">
          <div
            className="block full-height no-margin-bottom"
            id="chat"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div
              className="block-content chat-canvas"
              id="containers"
              ref={containers}
            >
              {reply.length !== 0 ? (
                reply.map((todo) => (
                  <div
                    className={`interaction-comment-container ${
                      todo.direction === "left" ? "reverse-row" : ""
                    } ${todo.date.dia ? "column" : ""} `}
                  >
                    {todo.date.dia !== "" && (
                      <div className="time">
                        {format(todo.date.dia, "dd 'de' MMMM", {
                          locale: ptBR,
                        })}
                      </div>
                    )}
                    {renderInteractionComment(todo)}

                    {/* <ImageProfile
                                  profile={{
                                      nome_usuario: formatEmoji(name) ?? "Não registrado",
                                  }}
                                  client={direction === "left" ? true : false}
                                  tooltip
                                  className="comment-list__profileImage"
                                  iconHistory={!name && "user"}
                                  /> */}
                  </div>
                ))
              ) : (
                <div className="empty-state__comment">
                  <MessageComment />
                  Envie um comentário por texto ou grave uma mensagem
                </div>
              )}
            </div>
            <div
              onClick={(event) => removeImageSplit(event)}
              style={{
                width: "150px",
                left: "20px",
                marginLeft: "5px",
                position: "relative",
              }}
              className="phone-dtmf active"
            >
              <img width="150" id="contein" src={""} />
            </div>
            <div className="block-footer">
              <div
                className={showReply ? "reply-message active" : "reply-message"}
              >
                {(() => {
                  if (showReply) {
                    var text = "";
                    var array = [];
                    var posit = "";
                    array = reply.filter((msg) => msg.id === idReplyMsg);
                    if (array.length !== 0 && array) {
                      posit = array[0].author;
                      let nameUser = convertUnicodeEmoji(array[0].username);

                      if (
                        array[0].author === "Me" ||
                        array[0].typemon !== "0"
                      ) {
                        if (array[0].username) {
                          nameUser =
                            InfoUsers.username === array[0].username
                              ? "Você"
                              : array[0].username;
                        } else {
                          nameUser = "Você";
                        }
                      }
                      if (array[0].typemsg === "11") {
                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">Contato</div>
                          </div>
                        );
                      } else if (
                        array[0].typemsg !== "0" &&
                        array[0].typemsg !== "2" &&
                        array[0].typemsg !== "4"
                      ) {
                        var url = array[0].attachment.path_arquivos;
                        url = url.split(".").pop();
                        switch (url.toLowerCase()) {
                          case "jpeg":
                          case "png":
                          case "jpg": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={FOTO} alt="" width="15" /> Imagem
                                </div>
                              </div>
                            );
                          }
                          case "pdf":
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={DOC} alt="" width="15" /> PDF
                                </div>
                              </div>
                            );
                          case "xls":
                          case "xlsx":
                          case "doc":
                          case "docx":
                          case "ppt":
                          case "pptx": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={DOC} alt="" width="15" /> DOC
                                </div>
                              </div>
                            );
                          }
                          case "wav":
                          case "mp3":
                          case "ogg":
                          case "mpeg": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={AUDIO} alt="" width="12" /> Áudio
                                </div>
                              </div>
                            );
                          }
                          case "mp4": {
                            return (
                              <div className="reply-message__container">
                                <div className="reply-message__name">
                                  {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                                  {nameUser}
                                </div>
                                <div className="reply-message__text">
                                  <img src={VIDEO} alt="" width="15" /> Vídeo
                                </div>
                              </div>
                            );
                          }
                        }
                      } else if (array[0].typemsg === "4") {
                        // text = array[0].message;
                        // if (text.length > 200)
                        //   text = text.substr(0, 200) + "...";
                        // text = text.replace(/¿/gi, "\n");
                        // text = text.replace(/§/gi, "\r\n");
                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">
                              Localização
                            </div>
                          </div>
                        );
                      } else {
                        text = array[0].text;
                        text = text.replace(/§/gi, "\r\n");

                        if (array[0].typemsg === "2") {
                          let msgSeparator = text.split("~¿");
                          text = msgSeparator[0];
                        }

                        text = text
                          .replace(/¿/gi, "\n")
                          .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "$1");

                        if (text.length > 200)
                          text = text.substr(0, 200) + "...";

                        return (
                          <div className="reply-message__container">
                            <div className="reply-message__name">
                              {/* {posit === "Me"
                                                ? "Você"
                                                : createJSON(ContactId.cliente)} */}
                              {nameUser}
                            </div>
                            <div className="reply-message__text">{text}</div>
                          </div>
                        );
                      }
                    }
                  }
                })()}
                <div
                  className="reply-message__close"
                  onClick={(event) => closeReply()}
                >
                  <i className="material-icons">close</i>
                </div>
              </div>
              <div
                className="message-box new-chat"
                // style={{display: "flex", justifyContent: "flex-end"}}
              >
                <div className="input-message">
                  <div
                    onKeyPress={handleKeyPress}
                    autoComplete="off"
                    type="text"
                    ref={(node) => (node = node)}
                    className="chat-message"
                    id="chat-message"
                    onKeyDown={handleKeyDown}
                    spellCheck="true"
                    onKeyUp={(event) => handleOnChange(event)}
                    onChange={(e) => setTextMessage(e.target.value)}
                    // onPaste={(event) =>
                    // this.handleOnChange2(event, InfoUsers, ContactId)
                    // }
                    // onFocus={event =>
                    //   this.handleOnFocus(event)
                    // }
                    contentEditable="true"
                    suppressContentEditableWarning={true}
                  />
                  {/* <a
                                      type="submit"
                                      className="close-quick"
                                      id="button-close-quick"
                                      onClick={() => this.cancelQuickAnswer()}
                                      style={{
                                      marginRight: "22px",
                                      display: this.state.editableQuickAnswer
                                          ? "block"
                                          : "none",
                                      }}
                                  >
                                      <i className="material-icons">close</i>
                                  </a> */}

                  <div
                    className={
                      recording ? "actions-chat" : "actions-chat active"
                    }
                  >
                    <div
                      className="content-emoji-popover"
                      contentEditable="true"
                      suppressContentEditableWarning={true}
                    ></div>
                    <Tooltippy content={"Adicionar Anexo"}>
                      <button
                        href="#"
                        className="btn action"
                        id="action-attachment"
                        data-tippy="Adicionar Anexo"
                      >
                        <label className="upload-input" htmlFor="file-input">
                          <IconUploadFile />
                        </label>
                        <input
                          style={{ display: "none" }}
                          type="file"
                          name="upload"
                          multiple
                          id="file-input"
                          onChange={(event) => handleselectedFile(event)}
                        />
                      </button>
                    </Tooltippy>
                    <Tooltippy content={"Enviar Áudio"}>
                      <button
                        href="#"
                        onClick={start}
                        disabled={permitrec}
                        className="btn action"
                        id="action-voice"
                        data-tippy="Atender em voz"
                      >
                        <IconAudio />
                      </button>
                    </Tooltippy>
                  </div>
                  <div
                    className={
                      recording ? "active-voice active" : "active-voice"
                    }
                  >
                    <a onClick={stop} className="cancel">
                      <i className="material-icons">close</i>
                    </a>

                    <div className="active-chats__timer active-chats__timer--active-voice">
                      {(() => {
                        if (recording === true)
                          return (
                            <>
                              <span className="active-chats__timer-icon active-chats__timer--active-voice-icon alta">
                                •
                              </span>
                              <TimeCounter horario={timeRecording} />
                            </>
                          );
                      })()}
                    </div>

                    <a onClick={stopIn} className="done">
                      <i className="material-icons">done</i>
                    </a>
                  </div>
                  <button
                    type="submit"
                    onClick={() => buttonSendMessage()}
                    className="send-message"
                    id="button-send-message"
                  >
                    {/* <i className="material-icons">send</i> */}
                    <IconSend />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <input type="hidden" id="simulation_click" name="simulation_click" />
    </div>
  );
};

export default Comment;
